export default __webpack_public_path__ + "static/media/img_header.160f7bfb.svg";